export default "__VITE_ASSET__DOUrZ9DG__"